import { Table } from 'components/tables/Table';
import { FC, useMemo } from 'react';
import { userLevelTableColumns } from './TableColumns';
import { useUserLevelFormContext } from './UserLevelFormContext';
import { RequestStatus } from 'types/RequestStatus';

const UserLevelTable: FC = () => {
	const { providerAccessLogs, accessEntriesStatus } =
		useUserLevelFormContext();

	const columns = useMemo(
		() => [
			userLevelTableColumns.providerCode(),
			userLevelTableColumns.firstName(),
			userLevelTableColumns.lastName(),
			userLevelTableColumns.email(),
			userLevelTableColumns.companyId(),
			userLevelTableColumns.companyName(),
			userLevelTableColumns.subscriptionType(),
			userLevelTableColumns.grantedAccess(),
			userLevelTableColumns.lostAccess(),
			userLevelTableColumns.realtime(),
		],
		[providerAccessLogs],
	);

	if (accessEntriesStatus === RequestStatus.UNLOADED) return null;

	return (
		<Table
			columns={columns}
			data={providerAccessLogs}
			requestStatus={accessEntriesStatus}
			withPagination
			paginationOptions={{
				initialPageSize: 10,
				showFromCount: 10,
			}}
		/>
	);
};

export default UserLevelTable;
